import type { CancelInvitations } from '@fourthwall/services/dist/ShopUsersApiClient'
import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { useMutation } from '@tanstack/react-query'

export const useCancelInvitationsMutation = () => {
  const cancelInvitationsMutation = useMutation({
    mutationFn: async (variables: CancelInvitations['Payload']) => {
      const { data } = await ShopUsersApiClient.cancelInvitations(variables)

      return data
    },
  })

  return { cancelInvitationsMutation }
}
